import { api } from '@/api'
import Button from '@/components/Button'
import ErrorAllText from '@/components/ErrorText/AllErros'
import Input from '@/components/Input'
import Spinner from '@/components/Spinner/Spinner'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { zheka2 } from '@/images'
import { resetPasswordSchema } from '@/utils/schemesFormik'
import { GxForm } from '@garpix/garpix-web-components-react'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import style from '../styles/reset.module.scss'

const ResetPassword = (): React.ReactElement => {
  const page = usePage()
  const { config } = page?.init_state?.global
  const [isSuccess, setSuccess] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: resetPasswordSchema,
    initialValues: {
      email: '',
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors }) {
      api
        .restorePassword(values)
        .then((data) => {
          setSuccess(true)
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm
  if (isSuccess) {
    return (
      <div className={style.reset_flex}>
        <div className={style.reset_left}>
          <Title type='h2' theme='h3' className={style.reset__title}>
            Письмо успешно отправлено!
          </Title>
          <p className={style.reset__text}>
            На указанную почту{' '}
            <span className={style.reset__mail}>{formik.values.email}</span> было
            отправлено письмо с инструкцией по восстановлению пароля!
          </p>
          <Button
            wide
            size='extralarge'
            highlight
            className={style.reset__field}
            href={config.authorization}
          >
            Вернуться к авторизации
          </Button>

          <Button
            wide
            size='extralarge'
            outline
            href={config.home_url}
            className={style.reset__field}
          >
            На главную
          </Button>
        </div>
        <img
          src={zheka2}
          width='435px'
          height='600px'
          alt=''
          className={style.reset__image}
        />
      </div>
    )
  }
  return (
    <div className={style.reset}>
      <Title type='h2' theme='h3' className={style.reset__title}>
        Сбросить пароль
      </Title>
      <p className={style.reset__text}>
        Для сброса пароля укажи свою электронную почту (email) и следуй инструкции по
        созданию нового пароля. Логин так же будет указан в письме.
      </p>
      <GxForm onGx-submit={onSubmit}>
        <Input
          name='email'
          label='Почта:'
          type='email'
          value={formik.values.email}
          onGx-input={formik.handleChange}
          className={style.reset__field}
          error={formik.errors.email}
        />
        {formik?.errors?.apiError === ''
          ? null
          : (
            <ErrorAllText text={formik.errors.apiError} className={style.reset__field} />
            )}
        <Button disabled={formik.isSubmitting} type='submit' wide size='extralarge' highlight>
          {formik.isSubmitting ? <Spinner /> : 'Отправить'}
        </Button>
      </GxForm>
    </div>
  )
}

export default ResetPassword
